import { ToolsTranslations } from '@/lib/translations/types';
import { DividendYieldResult } from './types';

interface Props {
  result: DividendYieldResult;
  translations: ToolsTranslations['dividendYield'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  const percentage = (result.yield * 100).toFixed(1);
  return (
    <div className="space-y-4">
      <div>
        <div className="text-sm font-medium text-gray-700 mb-2">{translations.resultLabel}</div>
        <div className="w-full rounded-md border border-gray-200 bg-gray-50 px-4 py-3 text-lg">
          {percentage} %
        </div>
      </div>
      <p className="text-xs text-gray-500">{translations.formulaNote}</p>
    </div>
  );
}


